import { useTranslation } from "react-i18next";
import { LANGUAGE_PAGES } from "@/lib/languagePages";
import { useLanguagePageClaims } from "@/lib/languagePageClaims";
import { formatUsdWhole } from "@/lib/money";

// "12 tutors from $15 to $48 per lesson" (#1643): worked out from the tutors a visitor can book, not
// typed into the page. The server answers null below three tutors, and then nothing is drawn: a page
// is never marked noindex for having none (#1017).
const LanguageClaims = ({ slug }: { slug: string }) => {
  const { t, i18n } = useTranslation();
  const code = LANGUAGE_PAGES.find((entry) => entry.slug === slug)?.code;
  const { data: claims } = useLanguagePageClaims(code);

  if (!claims) return null;

  return (
    <p
      className="mt-6 text-base md:text-lg font-medium text-muted-foreground max-w-3xl mx-auto"
      data-testid="language-claims"
    >
      {t("languagePage.claims", {
        count: claims.tutorCount,
        min: formatUsdWhole(claims.priceMinCents, i18n.language),
        max: formatUsdWhole(claims.priceMaxCents, i18n.language),
      })}
    </p>
  );
};

export default LanguageClaims;
